module.exports = __webpack_public_path__ + "static/case_details_01-c0a1b5c7b0b73bb6f6ea3c2715233e4c.jpg";